// activePropertySlides
import _ from 'lodash'
export default function (state, getters, rootState, rootGetters) {
  const routeName = rootState.route.name

  if (['carousel'].includes(routeName)) {
    switch (rootState.route.params.productType) {
      case 'land':
        return getters['property/land'].map(property => {
          return {
            backgroundImage: [...property.galleryImages][0],
            _id: property.id,
            images: [...property.galleryImages], 
            lotSize: property.size,
            name: property.label,
            price: property.price,
            type: 'land'
          }          
        })
    }

    return []
  }

  if (['packages', 'package-modal'].includes(routeName)) {
    let _packages = getters['property/livingOptionsPackages'].filter(_package => {
      return !_package.filter
    })  

    // filter out packages that dont have a property or dwelling
    _packages = _packages.filter(_package => {
      return _package.property && _package.dwelling
    })

    if (rootState.route.query.lotId) {
      _packages = _packages.filter(_package => {
        return _package.property._id === rootState.route.query.lotId
      })
    }

    _packages = _.sortBy(_packages, 'price')

    return _packages.map(_package => {
      return {
        backgroundImage: [..._package.dwelling.facadeImages, ..._package.dwelling.galleryImages, ..._package.property.viewImages, ..._package.property.galleryImages, ..._package.dwelling.floorplanImages[rootState.language.code]][0],
        baths: _package.dwelling ? _package.dwelling.baths : '',
        beds: _package.dwelling ? _package.dwelling.beds : '',
        builder: _package.dwelling ? _package.dwelling.builderLabel[rootState.language.code] || _package.dwelling.builderLabel['en']: '',
        colourScheme: _package.dwelling ? _package.dwelling.colourScheme : '',
        houseDesign: _package.dwelling ? _package.dwelling.houseDesign : '',
        cars: _package.dwelling ? _package.dwelling.cars : '',
        _id: _package.id,
        images: [..._package.dwelling.facadeImages, ..._package.dwelling.galleryImages, ..._package.property.viewImages, ..._package.property.galleryImages, ..._package.dwelling.floorplanImages[rootState.language.code]], 
        lotNumber: _package.property.label,
        lotSize: _package.property.size,
        dwellingSize: _package.dwelling.size,
        name:  _package.displayLabel[rootState.language.code] ||  _package.displayLabel['en'] || _package.label,
        price: _package.price,
        virtualTourUrl: _package.dwelling.virtualTourUrl,
        packageOverlayImage: _package.overlayImage,
        dwellingOverlayImage: _package.dwelling.overlayImage,
        type: 'package'
      }
    })
  }

  if (['turnkeys', 'turnkey-modal'].includes(routeName)) {
    const turnkeyTypes = rootGetters['styleTemplate']['turnkey-page'].types

    let turnkeys = getters['property/turnkeys']
      .filter(turnkey => {return !turnkey.filter && turnkeyTypes.includes(turnkey.type)})

    // sort by price
    turnkeys = _.sortBy(turnkeys, 'price')

    return turnkeys
  }

  if (['dwellings', 'dwelling-modal'].includes(routeName)) {
    const dwellingTypes = rootGetters['styleTemplate']['dwelling-page'].types
    let dwellings = getters['property/livingOptionsDwellings'].filter(dwelling => {
      return !dwelling.filter && dwellingTypes.includes(dwelling.type)
    })

    if (rootState.route.query.lotId) {
      dwellings = dwellings.filter(dwelling => {
        return dwelling.suitablePropertyIds.includes(rootState.route.query.lotId)
      })
    }

    if (rootState.route.query.dwellingType) {
      dwellings = dwellings.filter(dwelling => {
        return dwelling.type === rootState.route.query.dwellingType
      })
    }


    dwellings = _.sortBy(dwellings, 'price')
    
    return dwellings
      .map(dwelling => {
        return {
          backgroundImage: [...dwelling.facadeImages, ...dwelling.galleryImages, ...(dwelling.floorplanImages[state.language.code] || dwelling.floorplanImages.en)][0],
          baths: dwelling ? dwelling.baths : '',
          beds: dwelling ? dwelling.beds : '',
          builder: dwelling ? dwelling.builderLabel[rootState.language.code] || dwelling.builderLabel['en'] : '',
          colourScheme: dwelling ? dwelling.colourScheme[rootState.language.code] || dwelling.colourScheme['en'] : '',
          houseDesign: dwelling ? dwelling.houseDesign[rootState.language.code] || dwelling.houseDesign['en'] : '',
          cars: dwelling ? dwelling.cars : '',
          _id: dwelling._id,
          images: [...dwelling.facadeImages, ...dwelling.galleryImages, ...(dwelling.floorplanImages[state.language.code] || dwelling.floorplanImages.en)], 
          lotNumber: null,
          dwellingSize: dwelling.size,
          name: dwelling.displayName[rootState.language.code] || dwelling.displayName['en'] || dwelling.label,
          price: dwelling.price,
          virtualTourUrl: dwelling.virtualTourUrl,
          minimumFrontage: dwelling.fitsOnProperty,
          dwellingOverlayImage: dwelling.overlayImage,
          type: 'dwelling'
        }
    })
  }

  if (['favourites', 'favourite-modal'].includes(routeName)) {
    const favourites = getters['favourites/favourites']

    return favourites
      .map(favourite => {
        let type = ''
        if (favourite.propertyId && favourite.dwellingId) {
          type = 'package'
        } else if (favourite.dwellingId) {
          type = 'turnkey'
        } else if (favourite.type === 'house') {
          type = 'house'
        } else {
          type = 'land'
        }

        let backgroundImage = []
        let images = []
        if (type === 'package') {
          backgroundImage = [...favourite.dwelling.galleryImages, ...favourite.property.viewImages, ...favourite.property.galleryImages, ...(favourite.dwelling.floorplanImages[state.language.code] || favourite.dwelling.floorplanImages.en)][0]
          images = [...favourite.dwelling.galleryImages, ...favourite.property.viewImages, ...favourite.property.galleryImages, ...(favourite.dwelling.floorplanImages[state.language.code] || favourite.dwelling.floorplanImages.en)]
        }
        if (type === 'house') {
          backgroundImage = [...favourite.galleryImages, ...(favourite.floorplanImages[state.language.code] || favourite.floorplanImages.en)][0]
          images = [...favourite.galleryImages, ...(favourite.floorplanImages[state.language.code] || favourite.floorplanImages.en)]
        }
        if (type === 'turnkey') {
          backgroundImage = [...favourite.dwelling.galleryImages, ...favourite.dwelling.facadeImages][0]
          images = [...favourite.dwelling.galleryImages, ...favourite.dwelling.facadeImages, ...(favourite.dwelling.floorplanImages[state.language.code] || favourite.dwelling.floorplanImages.en)]
        }
        if (type === 'land') {
          backgroundImage = [...favourite.viewImages, ...favourite.galleryImages][0]
          images = [...favourite.viewImages, ...favourite.galleryImages]
        }
        

        return {
          backgroundImage: backgroundImage,
          baths: favourite.dwelling ? favourite.dwelling.baths : type === 'house' ? favourite.baths : '',
          beds: favourite.dwelling ? favourite.dwelling.beds : type === 'house' ? favourite.beds : '',
          builder: favourite.dwelling ?
            favourite.dwelling.builderLabel[rootState.language.code] || favourite.dwelling.builderLabel['en'] :
            type === 'house' ? favourite.builderLabel[rootState.language.code] || favourite.builderLabel['en'] : '',
          colourScheme: favourite.dwelling ? 
            favourite.dwelling.colourScheme[rootState.language.code] || favourite.dwelling.colourScheme['en'] : 
            type === 'house' ? 
              favourite.colourScheme[rootState.language.code] || favourite.colourScheme['en'] :
              '',
          houseDesign: favourite.dwelling ?
            favourite.dwelling.houseDesign[rootState.language.code] || favourite.dwelling.houseDesign['en'] : 
            type === 'house' ? 
              favourite.houseDesign[rootState.language.code] || favourite.houseDesign['en'] :
              '',
          cars: favourite.dwelling ? favourite.dwelling.cars : type === 'house' ? favourite.cars : '',
          _id: favourite._id,
          images: images,
          lotNumber: type === 'package' ?
            favourite.property.labelfavourite.property.label[rootState.language.code] || favourite.property.displayLabel['en'] || favourite.property.label :
            favourite.displayLabel[rootState.language.code] || favourite.displayLabel['en'] || favourite.label,
          lotSize: type === 'package' ? favourite.property.size : favourite.size,
          name: type === 'package' ? favourite.displayLabel[rootState.language.code] || favourite.displayLabel['en'] || favourite.label : '',
          price: favourite.price,
          packageOverlayImage: type === 'package' ? favourite.property.overlayImage : null,
          dwellingOverlayImage: type === 'package' ? favourite.dwelling.overlayImage : null,
          type: type
        }
    })
  }
  
  return []
}